import {
  getAuth,
  onAuthStateChanged,
  signInWithCustomToken,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getIDTokenFromAmpersandWebVC } from "./ampersand-web-vc-bridge";

export async function getFirebaseIdToken(): Promise<string> {
  const auth = getAuth();
  return new Promise((resolve, reject) => {
    const unmount = onAuthStateChanged(auth, (user) => {
      unmount();
      if (!user) {
        reject(new Error("User is not signed in"));
        return;
      }
      user.getIdToken().then(resolve).catch(reject);
    });
  });
}

export async function loginWithToken(code: string): Promise<void> {
  console.log(`loginWithToken code=${code}`);

  const fn = httpsCallable(getFunctions(), "getCustomToken");
  const result = await fn({ code });
  const token = result.data as string;
  console.log(`loginWithToken got token, signing in now`);
  await signInWithCustomToken(getAuth(), token);
}

export async function loginWithIdToken(idToken: string): Promise<void> {
  console.log(`loginWithIdToken idToken=${idToken}`);

  const fn = httpsCallable(getFunctions(), "getCustomToken");
  const result = await fn({ idToken });
  const token = result.data as string;
  console.log(`loginWithIdToken got token, signing in now`);
  await signInWithCustomToken(getAuth(), token);
}

export async function loginWithinWebView(iosUid: string): Promise<void> {
  console.log(`loginWithWebView iosUid=${iosUid}`);
  const idToken = await getIDTokenFromAmpersandWebVC(iosUid);
  if (!idToken) {
    throw new Error("Failed to get ID token");
  }
  const fn = httpsCallable(getFunctions(), "getCustomToken");
  const result = await fn({ idToken });
  const token = result.data as string;
  console.log(`loginWithToken got token, signing in now`);
  await signInWithCustomToken(getAuth(), token);
}
